import UsersListing from 'components/users/UsersListing'
import React from 'react'
import './Users.scss'

function UsersPage() {
  return <UsersListing />
}

export default UsersPage
